import "./TestReportTypeViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import ChipComponent from "../../../../../shared/components/chip/ChipComponent";
import RichTextEditorComponent from "../../../../../shared/components/rich-text-editor/RichTextEditorComponent";

interface TestReportTypeViewComponentProps {
    testDetails: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const extractBiomarkerNameFromId = (id: number | string, biomarker: any) => {
    const biomarkerObj = biomarker?.find((biomarker: any) => biomarker?.id === id);
    if (biomarkerObj) {
        return biomarkerObj?.name;
    }
    return '-';
}

const TestReportTypeViewComponent = (props: TestReportTypeViewComponentProps) => {
    const {
        testDetails,
        onEditModeOpen,
        canEdit
    } = props;
    if (!testDetails) return null;

    const layoutDetails = testDetails.testLayoutDetails?.[0];

    const renderBiomarkerDetails = () => {
        if (!layoutDetails?.biomarkerObj?.[0].title) {
            return <></>
        }
        return layoutDetails?.biomarkerObj?.map((table: any, index: number) => (
            <React.Fragment key={index}>
                <Grid item xs={12} sm={12} md={6} xl={6}>
                    <DetailsDataKeyValueComponent title="Title">{table?.title || '-'}</DetailsDataKeyValueComponent>
                </Grid>
                <Grid item xs={12} sm={12} md={6} xl={6}>
                    <DetailsDataKeyValueComponent title="Biomarkers">
                    {table?.biomarkerIds?.map((id: number) => <ChipComponent key={id}
                                                                             label={extractBiomarkerNameFromId(id, testDetails?.biomarker)}/>) || '-'}
                    </DetailsDataKeyValueComponent>
                </Grid>
            </React.Fragment>
        ));
    };

    return (
        <div className="test-report-type-view-component details-tab-data-content">
            <div className="details-tab-data-header">
                <div className="view-and-edit-title">Report Type</div>
                {canEdit && (
                    <div className="">
                        <ButtonComponent
                            className="white-space-nowrap"
                            type="button"
                            color="primary"
                            variant="outlined"
                            startIcon={<EditIcon/>}
                            fullWidth={true}
                            handleClick={onEditModeOpen}
                        >
                            Edit Details
                        </ButtonComponent>
                    </div>
                )}
            </div>
            <div className="details-tab-data-body">
                <Grid container spacing={2} className="pdd-top-0">
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent isHorizontal title="Report Type">
                            {layoutDetails?.layout || '-'}
                        </DetailsDataKeyValueComponent>
                    </Grid>
                </Grid>
                <div className="horizontal-line"/>
                <Grid container spacing={2} className="pdd-top-0">
                    {renderBiomarkerDetails()}
                </Grid>
                <DetailsDataKeyValueComponent title="Disclaimer">
                </DetailsDataKeyValueComponent>
                {layoutDetails?.disclaimer ? (<RichTextEditorComponent
                    value={layoutDetails?.disclaimer}
                    readOnly
                />) : "-"}
            </div>
        </div>
    );

};

export default TestReportTypeViewComponent;
